<script setup>
// FLOW-06 (Tasks 6.4, 6.6 e 6.7) — o que as páginas da aba PowerFlow mostram quando a lista ou a
// execução não chega (o PowerTools fora do ar, a execução que não é da conta): a frase no lugar do
// conteúdo, no painel e com o desenho dos vazios das telas aprovadas, e o "Tentar de novo". Sem ele, a
// lista vazia diria "Nenhum flow nesta conta", que não é verdade.
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  mensagem: { type: String, required: true },
  // A execução que não existe não volta tentando de novo.
  podeTentar: { type: Boolean, default: true },
});

const emit = defineEmits(['tentar']);

const { t } = useI18n();
</script>

<template>
  <div
    role="alert"
    class="flex flex-col items-center gap-3 px-6 py-12 text-center border rounded-pz border-n-weak bg-n-card shadow-pz"
    data-painel-de-falha
  >
    <span
      class="grid size-10 place-items-center rounded-xl bg-n-alpha-black2 text-n-slate-11"
    >
      <span class="i-lucide-cloud-off size-4" aria-hidden="true" />
    </span>
    <p class="mb-0 text-sm max-w-prose text-n-slate-11">{{ mensagem }}</p>
    <Button
      v-if="podeTentar"
      size="sm"
      variant="faded"
      color="slate"
      icon="i-lucide-rotate-cw"
      data-tentar-de-novo
      :label="t('POWER_TOOLS.POWERFLOW.RETRY')"
      @click="emit('tentar')"
    />
  </div>
</template>
